/**
 * @generated SignedSource<<482eb48ecf8f85a2dd86b821cab085c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetNoteFontSize = "LARGE" | "MEDIUM" | "SMALL";
export type WidgetNoteFontStyle = "BOLD" | "CURSIVE" | "DEFAULT";
export type WidgetNoteStyleInput = {
  backgroundColor?: string | null;
  fontColor?: string | null;
  fontSize?: WidgetNoteFontSize | null;
  fontStyle?: WidgetNoteFontStyle | null;
};
export type WidgetNotePageBackgroundSelectorMutation$variables = {
  noteId: string;
  pageId: string;
  value: WidgetNoteStyleInput;
};
export type WidgetNotePageBackgroundSelectorMutation$data = {
  readonly note: {
    readonly page: {
      readonly setStyle: {
        readonly backgroundColor: string | null;
        readonly fontSize: WidgetNoteFontSize;
        readonly fontStyle: WidgetNoteFontStyle;
        readonly id: string;
      };
    };
  };
};
export type WidgetNotePageBackgroundSelectorMutation$rawResponse = {
  readonly note: {
    readonly page: {
      readonly setStyle: {
        readonly backgroundColor: string | null;
        readonly fontSize: WidgetNoteFontSize;
        readonly fontStyle: WidgetNoteFontStyle;
        readonly id: string;
      };
    };
  };
};
export type WidgetNotePageBackgroundSelectorMutation = {
  rawResponse: WidgetNotePageBackgroundSelectorMutation$rawResponse;
  response: WidgetNotePageBackgroundSelectorMutation$data;
  variables: WidgetNotePageBackgroundSelectorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "noteId"
      }
    ],
    "concreteType": "NoteMutation",
    "kind": "LinkedField",
    "name": "note",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "pageId"
          }
        ],
        "concreteType": "NotePageMutation",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "style",
                "variableName": "value"
              }
            ],
            "concreteType": "WidgetNotePage",
            "kind": "LinkedField",
            "name": "setStyle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backgroundColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fontStyle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fontSize",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetNotePageBackgroundSelectorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetNotePageBackgroundSelectorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cb6e5067ed9e39a7d8e58f44aae74a99",
    "id": null,
    "metadata": {},
    "name": "WidgetNotePageBackgroundSelectorMutation",
    "operationKind": "mutation",
    "text": "mutation WidgetNotePageBackgroundSelectorMutation(\n  $noteId: ID!\n  $pageId: ID!\n  $value: WidgetNoteStyleInput!\n) {\n  note(id: $noteId) {\n    page(id: $pageId) {\n      setStyle(style: $value) {\n        id\n        backgroundColor\n        fontStyle\n        fontSize\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbfbd34a756e924a2a1a365dce60e94e";

export default node;
